export default __webpack_public_path__ + "static/supportImg3-1b651b11cf5b7fd2d274eae01cc8918d.png";